const formatCalendarDateTime = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? new Date(value.getTime()) : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const isoString = date.toISOString();
  const [datePart, timePart] = isoString.split("T");
  if (!datePart || !timePart) return null;
  const dateSegment = datePart.replace(/-/g, "");
  const timeSegment = timePart.replace(/:/g, "").replace(/\.\d{3}Z$/, "Z");
  return `${dateSegment}T${timeSegment}`;
};

const normalizeGuestList = (value) => {
  if (!Array.isArray(value)) return [];
  const seen = new Set();
  const guests = [];

  value.forEach((entry) => {
    if (typeof entry !== "string") return;
    const trimmed = entry.trim();
    if (!trimmed) return;
    const key = trimmed.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    guests.push(trimmed);
  });

  return guests;
};

const CALENDAR_ATTRIBUTION = "Booked via Haastia.";

const withHaastiaAttribution = (description) => {
  const trimmed = typeof description === "string" ? description.trim() : "";
  if (!trimmed) {
    return CALENDAR_ATTRIBUTION;
  }
  if (trimmed.toLowerCase().includes("booked via haastia")) {
    return trimmed;
  }
  return `${trimmed}\n\n${CALENDAR_ATTRIBUTION}`;
};

export const buildGoogleCalendarLink = ({
  startDate,
  endDate,
  title,
  description,
  location,
  timezone,
  guests,
} = {}) => {
  const start = formatCalendarDateTime(startDate);
  const end = formatCalendarDateTime(endDate);

  if (!start || !end) return "";

  const params = new URLSearchParams();
  params.set("action", "TEMPLATE");
  params.set("text", title || "Booking");
  params.set("dates", `${start}/${end}`);

  const details = withHaastiaAttribution(description);
  if (details) {
    params.set("details", details);
  }

  if (location) {
    params.set("location", location);
  }

  if (timezone) {
    params.set("ctz", timezone);
  }

  const normalizedGuests = normalizeGuestList(guests);
  if (normalizedGuests.length) {
    params.set("add", normalizedGuests.join(","));
  }

  return `https://calendar.google.com/calendar/render?${params.toString()}`;
};

export default buildGoogleCalendarLink;
